import { Accessor, createContext, JSX, useContext } from "solid-js";
import { HomeWebstoreTelescopeRouteData } from "../data/home_webstore_telescope_route_data";
import { useHomeWebstoreTelescope } from "../hooks/useHomeWebstoreTelescope";

export type HomeWebstoreTelescopeContextValue = {
  routeData: Accessor<HomeWebstoreTelescopeRouteData>;
  onBrandClick: (brandKey: string) => void;
} & ReturnType<typeof useHomeWebstoreTelescope>;

const HomeWebstoreTelescopeContext = createContext<HomeWebstoreTelescopeContextValue>();

export function useHomeWebstoreTelescopeContext() {
  const context = useContext(HomeWebstoreTelescopeContext);
  if (!context) {
    throw new Error("useHomeWebstoreTelescopeContext must be used within HomeWebstoreTelescopeProvider");
  }
  return context;
}

export function HomeWebstoreTelescopeProvider(props: {
  children: JSX.Element;
  value: HomeWebstoreTelescopeContextValue;
}) {
  return (
    <HomeWebstoreTelescopeContext.Provider value={props.value}>
      {props.children}
    </HomeWebstoreTelescopeContext.Provider>
  );
}
